import React from "react";
import { InputLabel, InputBase, FormHelperText, useMediaQuery } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import styled from "@emotion/styled";
import ShowPasswordValidation from "../CSelect/ShowPasswordValidation";
import { isEmpty } from "lodash";
import useStyles from "./styles";

const BootstrapInput = styled(InputBase)(({ isTablet }) => ({
  padding: 0,
  width: "100%",
  "& .MuiInputBase-input": {
    border: "none",
    fontSize: 14,
    padding: isTablet? "6px" :"8px",
    fontFamily: "Inter Tight",
    outline: "none",
    width: "100%",
    background: "transparent",
  },
}));

const FieldsetWrapper = styled("fieldset")(({ theme, error }) => ({
  borderRadius: "12px",
  padding: "5px 12px",
  border: error ? "1px solid red" : "1px solid rgba(18, 18, 21, 0.10)",
  backgroundColor: "#fff",
  fontFamily: "Inter Tight",
  transition: "border-color 0.3s ease",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

const Legend = styled("legend")(({ theme, error }) => ({
  fontSize: "13px",
  fontWeight: "500",
  padding: "0 5px",
  color: error ? "red" : "#0D0D0E",
  whiteSpace: "nowrap"
}));

function CInput(props) {
  const classes = useStyles();
  const {
    label = "",
    placeholder = "",
    required = false,
    error = false,
    helpertext = "",
    multiline = false,
    outline = "",
    passwordValidation = false,
    passValue = "",
    isWhiteBackground = false,
    InputProps,
    ...otherProps
  } = props;

  const passwordRegex =
    /^(((?=.*[a-z])(?=.*[A-Z]))((?=.*[a-z]))(?=.*[!@#$%+:^=<(){}[\]~>_?`|'";,.&*€₹£])((?=.*[A-Z])))(?=.{8,})/;

    const isTablet = useMediaQuery("(max-width:1024px)");
    
  return (
    <FormControl variant="standard" fullWidth required={required} error={error}>
      <FieldsetWrapper error={error}>
        {label && <Legend error={error}>{label}</Legend>}
        <BootstrapInput
          {...props}
          isTablet={isTablet}
          multiline={multiline}
          placeholder={placeholder}
          id="bootstrap-input"
          inputProps={InputProps}
        />
      </FieldsetWrapper>

      {passwordValidation &&
      !passwordRegex.test(passValue) &&
      !isEmpty(passValue) ? (
        <ShowPasswordValidation password={passValue} />
      ) : null}

      <FormHelperText error={error} style={{ fontFamily: "Inter Tight" }}>
        {helpertext}
      </FormHelperText>
    </FormControl>
  );
}

export default CInput;
